import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { DropdownMonthList, DropdownYearList, ShortDateDefault } from 'utils/Constant';
import { GetBookingType, GetPaymentType, money, ShortDate } from 'utils/helpers';

export const DetailPaymentReportService = (selectedFilter, selectedPeriodeMonth, selectedPeriodeYear, data, dateFrom, dateTo, bookingType, paymentType) => {
    let y = 20

    const doc = new jsPDF('p', 'mm', 'a4');

    const totalAmount = data.reduce((total, row) => {
        return total + Number(row.amount || 0);
    }, 0);

    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('DELALA KOST', 105, y, {align: 'center'});
    y = y + 8
    doc.text('Detail Payment Report', 15, y);
    y = y + 8

    // Change to default font size and font wight
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');

    if (selectedFilter === '1') {
        doc.text('Dari Tanggal : ' + ShortDate(dateFrom), 15, y);
        y = y + 5

        doc.text('Sampai Tanggal : ' + ShortDate(dateTo), 15, y);
        y = y + 5
    }
    
    if (selectedFilter === '2') {
        doc.text('Periode : ' + DropdownMonthList.find(x => x.value === selectedPeriodeMonth).label + ' ' + DropdownYearList.find(x => x.value === selectedPeriodeYear).label, 15, y);
        y = y + 5
    }

    doc.text('Tipe Booking : ' + (bookingType === '' ? 'All' : GetBookingType(bookingType)), 15, y);
    y = y + 5

    doc.text('Tipe Pembayaran : ' + (paymentType === '' ? 'All' : GetPaymentType(paymentType)), 15, y);
    y = y + 5

    doc.text('Total Amount : Rp ' + money(totalAmount), 15, y);
    y = y + 5

    const tableBody = data.map((row) => [
        row.rowNumber,
        ShortDate(row.paymentDate),
        row.tenantName, 
        row.roomNumber,
        ...(bookingType === '' ? [GetBookingType(row.bookingType)] : []),
        // ShortDate(row.checkInDate),
        // ShortDate(row.checkOutDate) === ShortDateDefault ? '-' : ShortDate(row.checkOutDate),
        'Rp ' + money(row.amount),
        GetPaymentType(row.paymentType),
        row.remark,
    ]);

    autoTable(doc, {
        startY: y,
        head: [[
            'No',
            'Tgl Bayar', 
            'Nama Tenant', 
            'No Kamar', 
            ...(bookingType === '' ? ['Tipe Booking'] : []),
            // 'Tgl Check In',
            // 'Tgl Check Out',
            'Jumlah',
            'Tipe Pembayaran',
            'Remark',
        ]],
        body: tableBody,
        styles: {
            fontSize: 8,
            cellPadding: 1,
            lineWidth: 0.1,
            halign: 'center', // horizontal center
            valign: 'middle', // vertical center
            overflow: 'linebreak'
        },
        headStyles: {
            fillColor: [215, 215, 215],
            textColor: 0,
            halign: 'center',
            valign: 'middle',
            lineWidth: 0.2,
            lineColor: 0
        },
        bodyStyles: {
            fillColor: [255, 255, 255],
            textColor: 0,
            lineWidth: 0.2,
            lineColor: 0
        },
        columnStyles: {
            // 2: {
            //     cellWidth: 34, // adjust as needed
            // }
            1: {
                cellWidth: 'wrap'
            },
            2: {
                halign: 'left'
            },
            5: {
                cellWidth: 'wrap',
                halign: 'right'
            },
        },
        alternateRowStyles: {
            fillColor: [255, 255, 255],
        },
        margin: { top: 15, bottom: 10 },
        pageBreak: 'auto',
        didDrawPage: (data) => {
            const pageCount = doc.internal.getNumberOfPages();
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.height;

            doc.setFontSize(8);
            doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`, data.settings.margin.left, pageHeight - 5);
        },
    });

    let yPos = doc.lastAutoTable.finalY + 10;
    const pageHeight = doc.internal.pageSize.height;

    if (yPos + 20 > pageHeight) {
        doc.addPage();
        yPos = 20;
    }

    // Open on new tab
    doc.output('dataurlnewwindow');
}